import React from "react";
import { ArrowUp } from "@piiqtechnologies/svg-icons";
import { PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const ChangeIndicator = ({ changePercentage, isFullColored = true, hideNull = true, isPercentage = true, }) => {
    const theme = useTheme();
    if (changePercentage === undefined || changePercentage === null) {
        if (hideNull)
            return React.createElement(React.Fragment, null);
        return React.createElement(PeekTypography, { color: theme.palette.info.main }, "N/A");
    }
    // Arrow, colour and text all read the rounded value, so a 0.4 change cannot show an up arrow
    // next to a printed "0".
    const rounded = Math.round(changePercentage);
    const variant = rounded > 0 ? "success" : rounded < 0 ? "error" : "info";
    const color = theme.palette[variant].main;
    return (React.createElement(PeekStack, { direction: "row", spacing: 0.25, alignItems: "center" },
        rounded !== 0 && (React.createElement(ArrowUp, { style: {
                transform: rounded < 0 ? "rotate(180deg)" : "none",
            }, color: color })),
        React.createElement(PeekTypography, { color: isFullColored ? color : theme.palette.info.main },
            rounded,
            isPercentage ? "%" : "")));
};
export default ChangeIndicator;
